// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"44":"fd524e6a","112":"2e0aecea","125":"266788b6","286":"0cdf8d33","290":"ea5e6f52","321":"da2669a4","391":"815d4f59","595":"0f298db3","612":"073800c8","621":"43bbb89a","763":"65641c67","768":"fa8d671e","791":"c2bb6b60","807":"7fa904f0","898":"3d08d74e","924":"ac195496"}[chunkId] + ".chunk.js";
};